import { faStar as faStarOff } from '@fortawesome/free-regular-svg-icons';
import {
  faStar as faStarOn,
  faStarHalfAlt as faStarHalf,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { STAR_RATING } from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';
import { getStars } from './helpers';

const Stars = ({ max, value, className, isNonMainDeal }) => {
  const stars = getStars(max, value);
  const label = `${stars.reduce((out, l) => out + l, 0)} ${STAR_RATING}`;
  const theme = useContext(ThemeContext);

  return (
    <>
      <figure className={classNames('stars', className)}>
        <figcaption hidden>{label}</figcaption>
        {stars.map((star, index) => {
          switch (star) {
            case 0:
              return (
                <FontAwesomeIcon
                  className="star star--off"
                  icon={faStarOff}
                  key={index}
                />
              );
            case 0.5:
              return (
                <FontAwesomeIcon
                  className="star star--half"
                  icon={faStarHalf}
                  key={index}
                />
              );
            case 1:
            default:
              return (
                <FontAwesomeIcon
                  className="star star--on"
                  icon={faStarOn}
                  key={index}
                />
              );
          }
        })}
      </figure>
      <style jsx>{`
        .stars {
          display: inline-flex;
          align-items: center;
          color: ${isNonMainDeal
            ? theme.colors.infoyellow
            : theme.colors.primary};
          margin: 0;
        }
        .stars--small {
          font-size: 0.75em;
        }
      `}</style>
    </>
  );
};

Stars.propTypes = {
  className: PropTypes.string,
  isNonMainDeal: PropTypes.bool,
  max: PropTypes.number,
  value: PropTypes.number,
};

Stars.defaultProps = {
  className: '',
  isNonMainDeal: false,
  max: 5,
  value: 3.5,
};

export default Stars;
